module.exports = __webpack_public_path__ + "img/evo-nolimit.60c6be01.png";